import { format } from "date-fns";
import { ptBR, enUS, es } from "date-fns/locale";

const LOCALES = { pt: ptBR, en: enUS, es };
export const dateLocale = (language) => LOCALES[language?.split("-")[0]] || ptBR;
export const chartRecords = (records, locale, pattern = "dd/MM") => [...records].reverse().map((record) => ({
  date: format(new Date(record.created_date), pattern, { locale }), peso: record.weight, imc: record.imc,
}));

export const IMC_CLASSES = [
  { max: 18.5, key: "underweight", color: "text-blue-400", range: "< 18,5" },
  { max: 25, key: "normal", color: "text-green-400", range: "18,5 – 24,9" },
  { max: 30, key: "overweight", color: "text-yellow-400", range: "25 – 29,9" },
  { max: 35, key: "obesity1", color: "text-orange-400", range: "30 – 34,9" },
  { max: 40, key: "obesity2", color: "text-red-400", range: "35 – 39,9" },
  { max: Infinity, key: "obesity3", color: "text-red-600", range: "≥ 40" },
];
export const classifyImc = (imc) => IMC_CLASSES.find((item) => imc < item.max);
export const changeColor = (value) => value < 0 ? "text-green-400" : value > 0 ? "text-red-400" : "text-foreground";